module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/solution-01-82b4f1503d880829b9f7c91a2be6f262.jpg";